import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV, environment, IEnvironment } from 'env/config';
import { take } from 'rxjs/operators';

import { Service } from '../entity';

import { DataService } from '../http/dataService';
import { IGeoServer } from '../interfaces/models';
import { D2CGeo } from '../models/d2cgeo.model';
import { Repository } from './repository';

@Service({
  model: D2CGeo,
})
@Injectable({ providedIn: 'root' })
export class MyWorldService extends Repository<IGeoServer> {
  constructor(
    @Inject(ENV) private env: IEnvironment,
    dataService: DataService
  ) {
    super({
      client: dataService,
      url: env.api.backend.geoserver.endpoint as string,
    });
  }

  getFsasByCoidOrCity(queryParams) {
    const body = new HttpParams({
      fromObject: {
        ...this.setMyWorldQuery(queryParams.typeName, queryParams.cqlFilter),
      },
    });

    const parameters = {
      sortBy: queryParams.sortBy,
    };

    const headers = Object.assign(
      {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/x-www-form-urlencoded',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Accept: '*/*',
      },
      environment.api.headers.d2cGeo
    );

    return this.getAllByPost(body, parameters, headers).pipe(take(1));
  }

  createFromDTO(item): IGeoServer {
    // return D2CGeoServiceAddress.createFromDTO(item.properties, item.id);
    return item;
  }

  private setMyWorldQuery(typeName: string, cqlFilter: string) {
    return {
      service: 'WFS',
      request: 'GetFeature',
      version: '2.0.0',
      typeName,
      outputformat: 'application/json',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      cql_filter: cqlFilter,
    };
  }
}
